export const GreenCircleCheck = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2779_62301)">
        <path
          d="M26 40.3992L17.6 31.9992L14.8 34.7992L26 45.9992L50 21.9992L47.2001 19.1992L26 40.3992Z"
          fill="currentColor"
        />
      </g>
      <rect x="2" y="2" width="60" height="60" rx="30" stroke="currentColor" strokeWidth="4" />
      <defs>
        <clipPath id="clip0_2779_62301">
          <rect width="48" height="48" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
